import { FC, useMemo } from "react";
import { Box, Typography, Divider, useTheme, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import Row from "./Row";
import getStyles from "./styles";

interface LuminaireFoundProps {
  articleNumber: string;
  varNumber?: string;
  lightFlux: number | string;
  power: number | string;
  loadPerKm: number | string;
  lampset: string;
  familyImage: string;
  lvkPngUrl: string;
}

const LuminaireFound: FC<LuminaireFoundProps> = ({
  articleNumber,
  varNumber,
  lightFlux,
  power,
  loadPerKm,
  lampset,
  familyImage,
  lvkPngUrl,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).LuminaireFound, [theme]);

  return (
    <Stack sx={styles.container}>
      <Box sx={styles.table}>
        <Typography variant="h3" sx={styles.title}>
          {t("Luminaire found")}
        </Typography>

        <Row label={t("Article Number")} value={`${articleNumber} ${varNumber ? ` / ${varNumber}` : ""}`} />
        <Row label={t("Luminous flux")} value={`${lightFlux} lm`} />
        <Row label={t("Power Consumption")} value={`${power} W`} />
        <Row label={t("Load per km")} value={`${Number(loadPerKm).toFixed(2)} W/km`} />
        <Row label={t("Lampset")} value={lampset} />
      </Box>

      <Stack sx={styles.images}>
        <Box
          component="img"
          src={familyImage}
          alt="Family Image"
          sx={styles.image}
        />
        <Box
          component="img"
          src={lvkPngUrl}
          alt="LVK Image"
          sx={styles.image}
        />
      </Stack>
    </Stack>
  );
};

export default LuminaireFound;
